import { TextField, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import Inputmask from 'inputmask'
import { observer } from 'mobx-react'
import React, { createRef, useEffect } from 'react'
import { FixedHeaderWithHint } from '../../../../utils/HOC/FixedHeaders'

type TextInputProps = {
	label?: string
	mask?: string
	hint?: string
	multiline?: boolean
	value: string
	onChange: React.ChangeEventHandler<HTMLInputElement>
	onBlur?: React.FocusEventHandler<HTMLInputElement>
	onFocus?: React.FocusEventHandler<HTMLInputElement>

	color?: string
	classNames?: string
}

export const TextInput = observer((props: TextInputProps) => {
	const styles = useStyles()

	const inputRef = createRef<HTMLDivElement>()

	console.log('class names:', props.classNames)

	useEffect(() => {
		if (
			props.mask === undefined ||
			props.mask === '' ||
			inputRef.current === null
		)
			return

		const inputMask = new Inputmask({
			mask: props.mask,
		})

		inputMask.mask(inputRef.current)
	}, [props.mask])

	return (
		<FixedHeaderWithHint
			className={clsx(styles.formBuilderTextInputRoot, props.classNames)}
			label={props.label}
			hint={props.hint}
		>
			<TextField
				fullWidth
				variant="outlined"
				size="small"
				multiline={props.multiline}
				value={props.value ?? ''}
				onChange={props.onChange}
				onBlur={props.onBlur}
				onFocus={props.onFocus}
				autoComplete="off"
				inputRef={inputRef}
				sx={{
					input: {
						color: props.color,
					},
				}}
				inputProps={{
					className: clsx(props.classNames),
				}}
			/>
		</FixedHeaderWithHint>
	)
})

const useStyles = makeStyles((theme: Theme) => ({
	formBuilderTextInputRoot: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},
}))
